import { ChangeEventHandler, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Input from '../Input/Input';
import SearchIcon from '@/icons/search.svg?react';
import CrossIcon from '@/icons/close.svg?react';
import './SearchInput.scss';

interface Props {
  onChange: (v: string) => void;
  value: string;
  className?: string;
  placeholder: string;
  name?: string;
  size?: 'sm';
}

export const SearchInput = forwardRef(
  (
    { onChange, value, name, className = '', placeholder, size }: Props,
    ref
  ) => {
    const { t } = useTranslation();

    const onCrossClick = () => {
      onChange('');
    };

    const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
      onChange(e.target.value);
    };

    return (
      <div
        className={classNames('SearchInput relative', className, {
          'SearchInput--sm': size === 'sm',
        })}
      >
        <div className='SearchInput__btn SearchInput__searchBtn Button--naked absolute'>
          <SearchIcon />
        </div>
        <Input
          ref={ref}
          name={name}
          onChange={handleChange}
          value={value}
          wrapperClassName='Input--SearchInput'
          placeholder={placeholder}
        />
        {value && (
          <button
            type='button'
            aria-label={t('productData.view.search.clear')}
            className='SearchInput__btn SearchInput__crossBtn Button--naked absolute flex items-center'
            onClick={onCrossClick}
          >
            <CrossIcon />
          </button>
        )}
      </div>
    );
  }
);
